module.exports = function getResource(label, vars = []) {
    const resources = { mostMention: 'Most Mentioned' };
    return resources[label];
};
